export default __webpack_public_path__ + "static/media/module2.58844e8e.jpg";